module.exports = "//public.getcloudapp.com/packs/media/images/card-generic-183e14526ecec8aa70638c29276b1416.png";